export const isValidName = /^[a-zA-Z !@#$%^&*(),.?":{}|<>]*$/;
export const phoneNumberRegex = /^\d{10}$/;

